import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const VoiceIntake = React.lazy(() => import("./VoiceIntake"));

// Hardcoded roles for the MVP (non-migrated pattern, like the vapi module).
// Hardening step: migrate to permissionLevel + backend modulePermissions registration.
const STAFF = ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "ADMIN", "HEALTHCARE_ROLE"];
const ADMINS = ["TENANT_MASTER_ADMIN", "TENANT_ADMIN", "ADMIN"];

const voiceIntakeModuleConfig: ModuleConfig = {
  id: "voice-intake",
  name: "Voice Intake",
  description: "Talk to the AI assistant — it asks the enquiry questions and fills the intake form for you.",
  icon: "🎙️",
  version: "0.1.0",
  enabled: true,
  category: "communication",
  order: 12,
  color: "#10b981",

  routes: [
    { path: "/voice-intake", component: VoiceIntake, permissions: STAFF, useLayout: true },
  ],

  navigation: [
    { path: "/voice-intake", label: "Voice Intake", icon: "🎙️", permissions: STAFF },
  ],

  permissions: {
    view: STAFF,
    create: STAFF,
    edit: STAFF,
    delete: ADMINS,
  },

  quickActions: [
    {
      label: "Start Voice Intake",
      path: "/voice-intake",
      icon: "🎙️",
      description: "Talk to the AI assistant to capture a new enquiry",
    },
  ],
};

export default voiceIntakeModuleConfig;
